<template>
    <div class="assetLeasing">
        <dataTop :Width='Width'/>
        <h2>{{companyName}}-管理资产出租情况分析</h2>
        <div style="display: flex;overflow: hidden;">
          <div style="flex:1 1 auto;margin-right:33px;min-width: 0;">
              <bar-charts :data='detail' title='资产柱形图'/>
          </div>
          <div style="width:479px;">
            <circular :data="slice"/>
          </div>
        </div>
        
        <container class="table-box">
            <div class="search">
                <el-form :form="form" inline>
                    <el-form-item label="产权证地址名称：">
                        <el-input v-model='form.certificateAddress' placeholder="请输入产权证地址名称" style="width:240px;"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="margin-right:10px;" @click="searchHandle" :loading='loading'>
                        查询
                        </el-button>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select style="width: 180px" v-model='form.companyId' placeholder="请选择">
                            <el-option
                                v-for="item in unitOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table">
                <el-table
                :data="dataList"
                stripe
                style="width: 100%;
                background-color:#061033;">
                    <el-table-column
                        prop="key"
                        min-height="80"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="managementEnterprise"
                        label="管理单位名称">
                    </el-table-column>
                    <el-table-column
                        prop="certificateAddress"
                        label="资产产权证地址">
                    </el-table-column>
                    <el-table-column
                        prop="buildingArea"
                        label="建筑面积">
                    </el-table-column>
                    <el-table-column
                        prop="assetSource"
                        label="资产来源">
                    </el-table-column>
                    <el-table-column
                        prop="contractStatus"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        prop="updateTime"
                        label="更新时间">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button  type="text" @click="checkHandle(scope.row)" style="color:#fff;">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination
                    background
                    layout="total,slot, prev, pager, next"
                    :page-size="10"
                    :current-page='form.page'
                    @current-change='handleTableChange'
                    :total="total">
                    <span class="page-left">第{{form.page}}/{{NumberDiv(total,10)}}页</span>
                </el-pagination>
            </div>
        </container>
    </div>
</template>
<script>
import dataTop from "../index/components/dataTop";
import barCharts from './components/barCharts.vue'
import circular from './components/circular.vue'
import container from "../index/components/container"
import {structureList,getAvgRentRate,getManageAssetCount} from "../../../api/bigDataContract.js";
import {getCompanyList} from '../../../api/contract.js'
import {getList} from '@/api/asset.js'
export default {
    name:'assetLeasing',
    data(){
        return{
          Width: 0,
          companyName:'',
          unitOptions:[],
          total: 0,
          loading: false,
          form:{
            certificateAddress:'',
            companyId:-1,
            page:1,
            perPage: 10,
          },
          dataList:[],
          slice:'0',
          detail:[],
        }
    },
    components:{
      barCharts,
      circular,
      dataTop,
      container
    },
    methods:{
        getWindowWidth() {
            this.Width = window.innerWidth
        },
        NumberDiv (arg1,arg2){
            var pages=arg1%arg2==0?(arg1/arg2):(Math.floor(arg1/arg2)+1);
            return Number(pages);
        },
        checkHandle(params){
            let routeData = this.$router.resolve({path:'/assetManagement/assetDetail',query:{assetId:params.assetId}})
            window.open(routeData.href, '_blank');
        },
        handleTableChange(page){
            this.form.page=page;
            this.getList();
        },

        getCompanyList(){
            getCompanyList({}).then(res => {
                let data = res.data
            if (data.code === '000') {
                this.unitOptions = data.content.list
            } else {
                this.unitOptions = []
            }
            }).catch(err => {
                console.log(err);
            })
        },
        getManageAssetCount(){
            let para = {companyId:this.form.companyId}
            getManageAssetCount(para).then(res => {
                let data = res.data
            if (data.code === '000') {
                this.detail = data.content.manageAssetList
            } else {
                this.detail = []
            }
            }).catch(err => {
                console.log(err);
            })
        },
        getAvgRentRate(){
            let para = {companyId:this.form.companyId}
            getAvgRentRate(para).then(res => {
                let data = res.data
            if (data.code === '000') {
                this.slice = (data.content*100).toFixed(2)
            } else {
                this.slice = 0
            }
            }).catch(err => {
                console.log(err);
            })
        },
        searchHandle(){
            this.form.page = 1
            this.getList();
        },
        getList() {
            let para=Object.assign({},this.form)
            this.loading = true;
            getList(this.form).then(res=>{
                let data=res.data;
            if(data.code==='000'){
                let arr = data.content.list
                for (let i in arr){
                    arr[i].key = Number(i)+1
                }
                this.dataList=arr;
                this.total=data.content.total;
                this.loading=false;
            }else{
                console.log(data.desc)
            }
            })
        },
    },
    created() {
      this.getCompanyList()
      if(this.$route.query.companyId){
        this.$nextTick(function () {
            this.form.companyId = Number(this.$route.query.companyId)
            this.companyName = this.$route.query.companyName
            this.getAvgRentRate()
            this.getManageAssetCount()
            this.getList()
        })
         
      } 
      
    },
    mounted() {
      this.getWindowWidth()
      window.addEventListener('resize', this.getWindowWidth)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth)
    }
}
</script>
<style lang="scss">
.table-box{
    .el-form-item > label {
        color: #fff;
    }
    .el-input__inner::placeholder{
        color:#fff;
        font-size:12px;
    }
    .el-form-item__content .el-button{
        background-color:#0A56C5;
        border-color:#0A56C5;
        margin-left: 10px;
        margin-right: 10px;
    }
    .el-input__inner{
        background-color:transparent;
        border-radius:4px;
        border:1px solid rgba(29,62,143,1);
        box-shadow:0px 0px 6px 2px rgba(17,24,110,1);
        margin-right:10px;
        color:#fff;
        font-size:12px;
        .el-select{
            background-color:transparent;
            color:#fff;
        }
    }
    .table{
        .el-table thead > tr > th{
            color:#06FBEC;
            background-color:#1D3E8F;
            border-bottom:none;
            padding: 13px 16px;
        }
        .el-table tbody tr > td{
            background-color:#061033;
            border-color:#1D3E8F;
            padding: 13px 16px;
            color:#fff;
        }
        tr {
            background-color:transparent !important;
        }
        .el-table tr:active {
            background-color:#1D3E8F !important;
        }
        .el-table::before {
            background-color:#1D3E8F !important;
        }
        .el-table__empty-block {
            background-color:#061033;
            color:#fff;
        }
    }
    .page {
        margin-top:40px;
        text-align:right;
        .el-pagination__total{
            color:#fff;
            float: left;
        }
        .page-left{
            font-weight: 400;
            color:#fff;
            float: left;
        }
        .el-pagination .btn-prev {
            color:#606266;          
            background: #FFFFFF !important;
            border-radius: 2px;
        }
        .el-pagination .btn-next {
            color:#606266;          
            background: #FFFFFF !important;
            border-radius: 2px;
        }
        .el-pager li {
            color:#606266;          
            background: #FFFFFF !important;
            border-radius: 2px;
        }
        .el-pager li.active {
            background: #0A56C5 !important;
            color:#fff !important;
            border-radius: 2px;
        }
    }
}
</style>

<style lang="scss" scoped>
.assetLeasing{
    padding: 0 15px 15px;
    background-color: #061033;
    min-height: 100vh;
    width: 100%;
    h2{
        color:#fff;
        margin:15px 0;
        font-size:24px;
    }
    .table-box{
        padding:15px 32px;
        margin-top:15px;
        .search{
            padding:0 10px;
            display: flex;
            align-items: center;
            h4{
                color:#B8D7FF;
                font-size:16px;
                margin:0;
            }
            i{
                color:#FF464B;
                font-size:16px;
                padding:0 10px;
            }
        }
        .table{
            margin-top:15px;
        }
    }
    

}
</style>


